import React from 'react';

// DO NOT EDIT - THIS FILE IS GENERATED
/* eslint-disable */

var productCareTumbleDryLowIcon = /*#__PURE__*/React.createElement("svg", {
  height: "24",
  width: "24",
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
}, /*#__PURE__*/React.createElement("g", {
  fill: "currentColor",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  d: "M13.268 9.422c0 .664-.542 1.21-1.209 1.21a1.213 1.213 0 0 1-1.208-1.21c0-.67.541-1.206 1.208-1.206.667 0 1.209.537 1.209 1.206m7.491 12.003h-17.4v-.485c0-.533.433-.965.967-.965h15.467c.534 0 .966.432.966.965v.485Zm0 2.575h-17.4v-.497c0-.527.427-.953.954-.953h15.493c.527 0 .953.426.953.953V24Z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M20.098 0c.4 0 .725.325.725.725v17.402a.723.723 0 0 1-.722.722H4.02a.722.722 0 0 1-.723-.722V.726c0-.401.324-.726.726-.726h16.075Zm-.725 1.45H4.747v15.949h14.626V1.449Z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M12.06 3.988a5.442 5.442 0 0 1 5.437 5.436 5.442 5.442 0 0 1-5.438 5.437 5.441 5.441 0 0 1-5.436-5.437 5.441 5.441 0 0 1 5.436-5.436Zm0 1.45a3.99 3.99 0 0 0-3.987 3.986 3.99 3.99 0 0 0 3.986 3.987 3.992 3.992 0 0 0 3.988-3.987 3.992 3.992 0 0 0-3.988-3.986Z"
})));

export { productCareTumbleDryLowIcon as default };
//# sourceMappingURL=productCareTumbleDryLowIcon.js.map
